import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  .c-slice {
    text-align: center;
  }

  .c-wrap {
    max-width: 1280px;
    margin: auto;
    padding: 0 24px;
  }

  .c-lay {
    width: 100%;
  }

  .c-lay-main {
    vertical-align: top;
    text-align: left;
  }

  li {
    font-size: 14px;
  }

  ul {
    margin-top: 0;
  }

  table,
  tr,
  td {
    border: 1px solid #e0e0e3;
    border-spacing: 0;
    font-size: 14px;
    vertical-align: top;
  }

  .c-lay-main .main-title,
  .c-lay-main h2 {
    font-family: 'Source Sans Pro', Trebuchet MS, Arial, Helvetica, sans-serif;
  }

  .c-lay-main .main-title {
    display: block;
    padding: 60px 0 12px 0;
    margin: 0 0 40px 0;
    font-size: 22px;
    font-weight: bold;
    text-transform: uppercase;
    color: #262626;
  }

  .main-title {
    display: inline;
    font-size: 22px;
    text-align: center;
  }

  .c-lay-main .main-title:after {
    display: block;
    content: '';
    margin: 12px auto 0 auto;
    height: 1px;
    width: 70px;
    background-color: #262626;
  }

  .c-lay-main h2 {
    padding: 16px 0 6px 0;
    font-size: 14px;
    color: #494949;
  }

  .c-lay-main p {
    font-size: 14px;
    color: #494949;
    text-align: justify;
  }

  .c-lay-main > p:last-child {
    padding-bottom: 60px;
  }

  .c-lay-main p.c-plist {
    padding-left: 14px;
  }

  .c-lay-main .u-center {
    text-align: center;
  }

  .c-lay-main p,
  .c-lay-main li {
    overflow-wrap: break-word;
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }

  .c-breadcrumb {
    max-width: 1280px;
    padding: 3px 24px;
    list-style-type: none;
    text-align: left;
    border-top: none;
  }

  .c-breadcrumb a {
    text-decoration: none;
    color: #db0237;
  }

  .c-breadcrumb span {
    display: inline-block;
    font-weight: 400;
    padding-left: 15px;
    font-size: 12px;
    line-height: 30px;
  }

  .c-breadcrumb span:first-child:before {
    content: '';
    padding-right: 0;
  }

  .c-breadcrumb span:before {
    content: '>';
    position: relative;
    top: 2px;
    color: #e0e0e3;
    padding-right: 15px;
    font-weight: 800;
    font-size: 16px;
  }

  .list-dash {
    list-style-type: none;

    li:before {
      content: '-';
      position: absolute;
      margin-left: -1em;
    }
  }
`
const ClassementReferencement = () => (
  <Container>
    <div className="c-slice">
      <div className="c-wrap">
        <div className="c-breadcrumb">
          <span>
            <a href="https://www.seloger.com/">SeLoger.com</a>
          </span>
          <span>Fonctionnement de notre site</span>
        </div>
        <div className="c-lay">
          <div className="c-lay-main">
            <h1 className="u-center main-title">Fonctionnement de notre site</h1>
            <p>
              La présente rubrique a pour objet de définir les conditions de référencement, de déférencement et de classement des annonces sur le site{' '}
              <a href="https://www.seloger.com/" target="_blank" rel="noopener noreferrer">
                www.seloger.com
              </a>{' '}
              («&nbsp;le Site&nbsp;») édité par la société Digital Classifieds France («&nbsp;la société DCF&nbsp;»).
            </p>
            <p>
              La société DCF met à la disposition des utilisateurs du Site («&nbsp;les Utilisateurs&nbsp;») des services décrits dans les Conditions Générales d’Utilisation du
              Site, consistant à faciliter les démarches de l’Utilisateur dans son projet immobilier, en lui permettant notamment de consulter des annonces de biens immobiliers sur
              le Site et d’entrer le cas échéant en relation avec les auteurs de ces annonces («&nbsp;les Annonceurs&nbsp;»).
            </p>
            <p>
              La société DCF ne garantit pas la conclusion de relation contractuelle entre l’Utilisateur et lesdits Annonceurs et n’intervient à ce titre à aucun moment dans les
              échanges et transactions entre les Utilisateurs et les Annonceurs et n’intervient pas en tant que médiateur entre les Utilisateurs et les Annonceurs.
            </p>
            <h2>1. RÉFÉRENCEMENT ET DERÉFÉRENCEMENT DES ANNONCEURS :</h2>
            <h2>(i) Référencement des Annonceurs :</h2>
            <p>La diffusion d’annonces sur le Site est réservée aux Annonceurs définis ci-dessous :</p>
            <p>
              (i) Annonceurs professionnels ayant souscrit à titre payant un contrat de diffusion d’annonces de vente de biens immobiliers avec la société DCF et entrant dans l’une
              des catégories suivantes :
            </p>
            <ul type="circle">
              <li>les professionnels de l’immobilier détenant une carte de transaction ou de gestion conformément à la loi Hoguet n° 70-9 du 2 janvier 1970,</li>
              <li>les notaires,</li>
              <li>les avocats exerçant à titre accessoire l’activité de mandataire en transactions immobilières,</li>
              <li>les huissiers,</li>
              <li>les promoteurs immobiliers,</li>
              <li>les constructeurs.</li>
            </ul>
            <p>
              (ii) Annonceurs particuliers ayant préalablement accepté les Conditions Générales de Souscription d’annonces sur le Site SeLoger (ci-après «&nbsp;l’Annonceur
              Particulier&nbsp;»). La diffusion d’annonces est gratuite pour les Annonceurs Particuliers.
            </p>
            <h2>(ii) Référencement des Annonces :</h2>
            <p>Pour être référencée sur le Site et donc diffusée, une Annonce doit impérativement respecter les règles décrites ci-dessous.</p>
            <ul type="disc">
              <li>
                <h2 style={{ textDecoration: 'underline' }}>Contenu de l’Annonce</h2>
              </li>
            </ul>
            <p>Le bien doit être diffusé dans sa catégorie et être conforme aux produits de diffusion souscrits par l’Annonceur. Sur le Site, l’Annonce ne peut porter que sur :</p>
            <ul className="list-dash">
              <li>la vente et la location de biens anciens, ayant déjà fait l’objet d’un transfert de propriété;</li>
              <li>la vente de lots associés à des programmes immobiliers neufs, n’ayant pas encore fait l’objet d’un transfert de propriété.</li>
            </ul>
            <p>
              L’Annonceur doit également s’assurer que l’Annonce contient toutes les mentions et informations obligatoires. L’Annonce doit notamment être strictement conforme à la
              Charte de diffusion de SeLoger accessible depuis le lien suivant :
              <br />
              <a href="https://support.myselogerpro.com/hc/fr/articles/360006057939-Charte-SeLoger">https://support.myselogerpro.com/hc/fr/articles/360006057939-Charte-SeLoger</a>
            </p>
            <ul type="disc">
              <li>
                <h2 style={{ textDecoration: 'underline' }}>Contenu interdit au sein d’une Annonce</h2>
              </li>
            </ul>
            <p>
              Toute Annonce contenant des éléments qui sembleraient contraires aux dispositions légales ou réglementaires, aux bonnes mœurs, aux règles de diffusion de notre Site
              ou susceptible de heurter les Utilisateurs sera immédiatement refusée par la société DCF, donc non référencée sur le Site.
            </p>
            <p>Est notamment strictement interdit :</p>
            <ul type="circle">
              <li>Tout contenu rédigé en langue étrangère comportant des termes ou des descriptions sans lien avec le contenu proposé ;</li>
              <li>Tout contenu comportant des termes ou des descriptions sans lien avec le contenu proposé ;</li>
              <li>Tout contenu portant sur un bien immobilier ou programme de construction fictif ;</li>
              <li>Tout contenu frauduleux, ou visant à tromper l’Utilisateur ;</li>
              <li>Tout contenu à caractère politique, religieux ou haineux ;</li>
              <li>Tout contenu à caractère promotionnel et/ou publicitaire ;</li>
              <li>Toute image ou photographie sans lien avec l’offre proposée, non autorisée, contrefaisante, ou encore à caractère pornographique.</li>
            </ul>
            <h2>(iii) Déréférencement des Annonces et Annonceurs :</h2>
            <p>
              En cas de non-respect par l’Annonceur de ses engagements contractuels et / ou de la réglementation en vigueur et en particulier celle applicable aux Annonceurs
              professionnels de l’immobilier et/ou des règles de référencement décrites ci-dessus et de la Charte de diffusion accessible ici, la société DCF se réserve le droit,
              de refuser ou de bloquer la publication d’Annonces et / ou de suspendre le compte ou de résilier le contrat de l’Annonceur, sans notification préalable le cas
              échéant.
            </p>
            <p>
              La suppression puis la création, à l’identique, des mêmes Annonces immobilières est strictement interdite. La société DCF se réserve ainsi le droit de les
              déréférencer et/ou de suspendre le compte ou de résilier le contrat de l’Annonceur en cas de réitération.
            </p>
            <p>
              De même, dans le cas où la société DCF, en sa qualité d’hébergeur de l’Annonce, devait être rendue destinataire d’un signalement ou d’une notification émanant d’une
              autorité nationale ou européenne, lui faisant part du caractère manifestement illicite et/ou frauduleux de l’Annonce, celle-ci se réserve le droit, sans notification
              préalable, de bloquer la publication de l’Annonce ou de suspendre ou de supprimer le compte de l’Annonceur et de résilier son contrat.
            </p>
            <p>
              Il en est notamment ainsi dans l’hypothèse où l’Annonceur (i) ne disposerait pas des droits de propriété intellectuelle sur le contenu de l’Annonce et/ou (ii) ne
              disposerait pas de la propriété et/ou jouissance du bien et/ou le cas échéant, des autorisations requises, en particulier du propriétaire du bien, en vue de la
              diffusion de l’Annonce présentant le bien.
            </p>
            <h2>(iv) Signalement de contenu illégal :</h2>
            <p>
              DCF permet aux Utilisateurs de son Site de signaler tout contenu illégal, telle qu’une arnaque, une tentative de fraude, un comportement suspect, une contrefaçon ou
              encore toute infraction aux dispositions légales et réglementaires. Ces signalements peuvent être envoyés directement à la société DCF depuis la page de l’Annonce ou
              de l’Annonceur.
            </p>
            <h2>2. CLASSEMENT DES ANNONCES :</h2>
            <h2>(i) L’Utilisateur dispose de la possibilité de personnaliser son tri ou de spécifier les critères de préférence selon les critères suivants :</h2>
            <ul type="disk">
              <li>Prix croissant / décroissant</li>
              <li>Surface croissante / décroissante</li>
              <li>
                Prix au m<sup>2</sup> croissant / décroissant
              </li>
              <li>Date</li>
            </ul>
            <p>
              L’Utilisateur peut également filtrer les résultats des Annonces afin de consulter uniquement des Annonces d’Annonceurs professionnels ou d’Annonceurs particuliers.
            </p>
            <h2>(ii) Classement par défaut :</h2>
            <p>
              Le tri par défaut des Annonces (intitulé «&nbsp;Tri par Sélection&nbsp;») sur la page de résultats du Site est l’ordre d’affichage des Annonces qui s’applique
              automatiquement à partir du moment où l’Utilisateur n’a pas personnalisé son tri ou spécifié des critères de préférence.
            </p>
            <p>Les Annonces sont affichées par défaut dans l’ordre de priorité suivant :</p>
            <ol>
              <li>Typologie de l’Annonceur</li>
            </ol>
            <p>
              Si l’Annonce est publiée par un Annonceur professionnel ou un Annonceur particulier, le site étant avant tout une plateforme pour les Annonceurs professionnels, les
              Annonces publiées par des Annonceurs professionnels auront une plus grande visibilité en liste de résultats du Site.
            </p>
            <ol start={2}>
              <li>Option payante</li>
            </ol>
            <p>
              Selon l’option payante éventuellement activée par l’Annonceur professionnel sur une ou plusieurs de ses Annonces, celles-ci pourront bénéficier, dans le tri initial
              par défaut du Site SeLoger, d’une priorité d’affichage en liste de résultats du Site. L’ordre d’affichage prioritaire s’effectue en fonction de l’option activée par
              l’Annonceur professionnel sur l’Annonce et du degré de mise en avant octroyée par chaque option.
            </p>
            <ol start={3}>
              <li>Qualité de l’annonce</li>
            </ol>
            <p>
              Pour une même typologie d’Annonce et/ou d’option payante, les Annonces sont priorisées en fonction de leur qualité. Ainsi, plus l’Annonce est complète, plus elle sera
              priorisée dans la liste de résultats du Site. Plusieurs critères sont pris en compte pour déterminer la qualité d’une Annonce, et notamment les coordonnées de
              géolocalisation du bien, les visuels accompagnants le bien, les informations sur le bien, etc …
            </p>
            <p>A qualité identique, le tri s’effectuera aléatoirement par l’indexation naturelle de la base de données</p>
            <h2>(iii) Suggestion :</h2>
            <p>
              L’Utilisateur pourra se voir également suggérer des Annonces susceptibles de l’intéresser (intitulées «&nbsp;Suggestion&nbsp;» ou «&nbsp;Sponsorisée&nbsp;» ). Ces
              suggestions sont sélectionnées en fonction (i) des critères de recherche de l’Utilisateur (types de biens recherchés, localité, prix, surface) et (ii) de la formule
              d’abonnement et des options payantes éventuellement activées par l’Annonceur.
            </p>
            <h2>3. CLASSEMENT DE L’ANNUAIRE DES ANNONCEURS PROFESSIONNELS :</h2>
            <p>Le classement par défaut de l’annuaire est réalisé en fonction de la date de mise en ligne de la page de l’Annonceur (de la plus récente à la moins récente).</p>
          </div>
        </div>
      </div>
    </div>
  </Container>
)

export default ClassementReferencement
